/** @format */
import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { StateService } from '@uirouter/core';
import { Observable } from 'rxjs';
import { AuthService, EnvironmentService } from 'sis-common';
import { OrganisationNameService } from '../organisation/organisation-name.service';
import { UniversityService } from '../service/university.service';

@Component({
    selector: 'sis-logout-page',
    templateUrl: './logout-page.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LogoutPageComponent implements OnInit {
    universityName$: Observable<string>;

    private loginState: string;

    constructor(
        private universityService: UniversityService,
        private organisationNameService: OrganisationNameService,
        private stateService: StateService,
        private environmentService: EnvironmentService,
        private authService: AuthService,
    ) {}

    ngOnInit(): void {
        const appName = this.environmentService.frontendName.toLowerCase();
        this.loginState = `${appName}.login`;

        if (this.authService.loggedIn()) {
            this.stateService.go(this.loginState);
            return;
        }

        this.universityName$ = this.organisationNameService.getOrgName(this.universityService.getCurrentUniversityOrgId());
    }

    navigateToLogin(): void {
        this.stateService.go(this.loginState);
    }
}
